import { menuItemClasses } from '@mui/material/MenuItem';
import { Theme, alpha } from '@mui/material/styles';

export const profileMenuStyles = (theme: Theme, isDark: boolean) => ({
  avatar: {
    width: 36,
    height: 36,
    [theme.breakpoints.down('lg')]: {
      width: 32,
      height: 32
    }
  },
  menuText: {
    fontVariationSettings: "'wght' 400",
    color: theme.palette.text.primary
  },
  listItemIcon: {
    minWidth: 0,
    '& svg': {
      width: 20,
      height: 20,
      [theme.breakpoints.down('md')]: {
        width: 20,
        height: 20
      }
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: 0,
    pr: 0,
    pl: 1,
    mx: 1,
    py: 0,
    '&:hover': {
      backgroundImage: theme.palette.action.focus,
      borderRadius: 2.5,
      backgroundColor: isDark
        ? 'transparent'
        : alpha(theme.palette.primary.main, 0.24),
      '& .MuiListItemIcon-root': {
        backgroundColor: 'none'
      }
    },
    [theme.breakpoints.up('sm')]: {
      pb: 1,
      py: 1
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 46
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 40
    }
  },
  menu: {
    py: 2,
    '&:hover': {
      backgroundColor: 'none',
      cursor: 'pointer'
    },
    [theme.breakpoints.up('sm')]: {
      '& ul': { py: 1.5 }
    }
  },
  menuBox: {
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    '&:hover': {
      backgroundColor: 'none',
      cursor: 'pointer'
    }
  },
  paperProps: {
    width: 220,
    overflow: 'visible',
    mt: 1.5,
    borderRadius: '12px',
    backgroundColor: isDark ? 'rgb(14 15 28)' : '#eaf0fd',
    boxShadow: isDark
      ? '0px 8px 12px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.05)'
      : '0px 0px 0px 1px rgba(150, 150, 150, 0.035),0px 8px 28px rgba(22, 22, 26, 0.08)',
    color: 'secondary',
    '&::before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 5000
    },
    [` & .${menuItemClasses.gutters}:hover`]: {
      color: theme.palette.primary.main,
      backgroundColor: 'none',
      '& p': {
        fontWeight: 600
      },
      '& svg': {
        fill: theme.palette.primary.main
      }
    }
  }
});
